import React from "react";
import { Templates, useTemplate } from "@/util-react/template";
import { HomePageDefaultDesktop } from "@/pages-react/home-page/templates/home-page.default";
import { HomePageBlackAndBlueDesktop } from "@/pages-react/home-page/templates/home-page.black-and-blue";

const templates: Record<Templates, React.ComponentType | null> = {
  [Templates.DEFAULT]: HomePageDefaultDesktop,
  [Templates.BLACK_AND_BLUE]: HomePageBlackAndBlueDesktop,
};

export const HomePageDesktop = () => {
  const template = useTemplate();

  const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

  return TemplatedComponent ? <TemplatedComponent /> : null;
};
